import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { AccountingChartResource } from "@exonn/js-sdk";

/**
 * Charts of accounts (SKR03 / SKR04 / custom), one operative chart per owner.
 *
 * Read-only here: a chart is created in the owner's "Buchhaltung" tab, where the
 * owner is fixed and the lock-in after the first posting is explained. The backend
 * offers neither update nor destroy — a later chart change is its own migration
 * process, not an edit.
 */
export const module: ModuleOptions<AccountingChartResource> = {
  resource: ResourceEnum.AccountingChart,
  bigIcon: <span className={"icon-20-book-alt"} />,
  smallIcon: <span className={"icon-15-book-alt"} />,
  disableCreate: true,
  disableDelete: true,
  tabs: {
    edit: {
      titleProp: "title",
    },
  },
};
